enum DROP_OFF_TYPE {
  HAND_TO_ME = 0, // 当面交付
  LEAVE_AT_DESIGNATED_SPOT = 1, // 放到指定地点
}

enum DROP_OFF_SPOT_TYPE {
  UNSELECTED = 0, // 未选择
  MY_DOOR = 1, // 家门口
  LOBBY = 2, // 大堂
  FRONT_DESK = 3, // 前台
  OTHER = 4, //  其他
}

enum DROP_OFF_SOURCE_TYPE {
  CONFIRM = 0,
  ADDRESS = 1,
}

export {
  DROP_OFF_TYPE,
  DROP_OFF_SPOT_TYPE,
  DROP_OFF_SOURCE_TYPE,
};
